import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

export const HEADER_LABELS = {
  products: 'Products',
  solutions: 'Solutions',
  resources: 'Resources',
  company: 'Company',
  language: 'English',
  demo: 'Request a demo',
};

export const PRODUCT_OPTION = [
  {
    name: 'INDIVIDUAL PRODUCTS',
    url: '',
    order: 1,
    orderpc: 0,
    child: [
      {
        id: 'gst',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/gst`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974643_group10000041431.png',
        title: 'GST',
        desc: 'G1-G9 filing ASP/GSP solution',
      },
      {
        id: 'Accounts Payable',
        url: 'https://www.clear.in/ap-automation-software',
        icon: 'https://assets.clear.in/cleartax/images/1702036465_group181447822.png',
        title: 'Accounts Payable',
        desc: 'Elevate processes with AI automation and vendor delight',
      },
      {
        id: 'vendor-management',
        url: `https://cleartax.in/vendor-management-software`,
        icon: 'https://assets.clear.in/cleartax/images/1719471777_group1000004140.svg',
        title: 'Vendor Management',
        desc: 'Streamline vendor management and collaboration in one unified portal',
      },
      {
        id: 'maxITC',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/max-itc`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974439_group1000004144.png',
        title: 'MaxITC',
        desc: 'Optimise ITC for profitability',
      },
      {
        id: 'e-invoice_bill',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/e-invoicing-enterprise-software`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974427_group1000004146.png',
        title: 'E-Invoicing & E-Way Bill',
        desc: 'Bulk invoicing within any ERP',
      },
      {
        id: 'tds',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/tds`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974413_group1000004148.png',
        title: 'TDS',
        desc: 'e-TDS return filing solution',
      },
      {
        id: 'einvoicing_discounting',
        url: 'https://clear.in/invoice-discounting',
        icon: 'https://assets.clear.in/cleartax/images/1702037563_cleartds.png',
        title: 'Invoice Discounting',
        desc: 'Maximise EBITDA with early vendor payments',
      },
      {
        id: 'financing',
        url: 'https://www.clear.in/invoice-financing',
        icon: 'https://assets.clear.in/cleartax/images/1702036542_financing.png',
        title: 'Financing',
        desc: 'Instant working capital financing',
      },
      {
        id: 'cimplyfive',
        url: `https://www.clear.in/s/secretarial-automation-software`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974740_group1000003267.png',
        title: 'CimplyFive',
        desc: 'Automated secretarial compliance',
      },
    ],
  },
  {
    name: 'PRODUCT SUITES',
    url: '',
    order: 2,
    orderpc: 2,
    child: [
      {
        id: 'cfc',
        url: `https://www.clear.in/clear-finance-cloud`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974199_group1000004141.png',
        title: 'Clear Finance Cloud',
        desc: 'Connected finance ecosystem for process automation, greater control, higher savings and productivity',
      },
      {
        id: 'compliance_cloud',
        url: `https://cleartax.in/s/clear-compliance-cloud`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974194_group1000004142.png',
        title: 'Clear Compliance Cloud',
        desc: 'GST and direct tax compliance',
      },
      {
        id: 'cscc',
        url: `https://cleartax.in/supply-chain-automation-solution`,
        icon: 'https://assets.clear.in/cleartax/images/1716990871_supplaychain_.svg',
        title: 'Clear Supply Chain Cloud',
        desc: 'Complete supply chain solution for ultimate control, effortless collaboration, and assured compliance',
      },
    ],
  },
  {
    name: 'CONSUMER PRODUCTS',
    url: '',
    bgColor: '#F4F9FF',
    order: 0,
    orderpc: 1,
    child: [
      {
        id: 'itr',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676974114_group1000004140.png',
        title: 'Self ITR Filing',
        desc: 'File your taxes in 3 minutes',
      },
      {
        id: 'tax_experts',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/pricing`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683876285_taxconsultant.png',
        title: 'Expert Assisted Filing',
        desc: "ITR filed by India's top tax experts",
      },
    ],
  },
];

export const SOLUTIONS_OPTIONS = [
  {
    name: 'For Leadership',
    url: '',
    child: [
      {
        id: 'cfo',
        url: `https://cleartax.in/s/enterprise-CFOs`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676976771_group18144784.png',
        title: 'CFO',
      },
    ],
  },
  {
    name: 'For Industries',
    url: '',
    child: [
      {
        id: 'fmcg',
        url: `https://www.clear.in/fmcg-solutions`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676976930_group18144781.png',
        title: 'FMCG',
      },
      {
        id: 'manufacturing',
        url: `https://www.clear.in/manufacturing-solutions`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676976936_group1000004118.png',
        title: 'Manufacturing',
      },
      {
        id: 'logistics',
        url: `https://www.clear.in/logistics-solutions`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676976943_group1000004116.png',
        title: 'Logistics',
      },
      {
        id: 'automotive',
        url: `https://www.clear.in/automotive-solutions`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676976949_group1000004138.png',
        title: 'Automotive',
      },
      {
        id: 'startups',
        url: `https://cleartax.in/s/start-up`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1676976955_group10000024551.png',
        title: 'Startups',
      },
    ],
  },
];

export const RESOURCES_OPTIONS = [
  {
    name: 'READ',
    url: '',
    child: [
      {
        id: 'case_studies',
        url: `https://cleartax.in/s/enterprise-case-studies`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196404_case_studies.png',
        title: 'Case Studies',
      },
      {
        id: 'opinion_notes',
        url: `https://cleartax.in/s/enterprise-whitepapers`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683877966_opinion_notes.png',
        title: 'Opinion Notes',
      },
      {
        id: 'product_guides',
        url: `https://docs.cleartax.in/product-help-and-support/`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196200_product_guides.png',
        title: 'Product Guides',
      },
      {
        id: 'newsroom',
        url: `https://news.cleartax.in/`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196211_newsroom.png',
        title: 'Newsroom',
      },
      {
        id: 'blog',
        url: `https://cleartax.in/income-tax-efiling?#guide-section`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196222_blog.png',
        title: 'Blog',
      },
    ],
  },
  {
    name: 'WATCH',
    url: '',
    child: [
      {
        id: 'webinars',
        url: `https://cleartax.in/s/webinars`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196239_webinars.png',
        title: 'Webinars',
      },
      {
        id: 'product_guides',
        url: `https://docs.cleartax.in/product-help-and-support/video-tutorials`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196252_product_guidevideos.png',
        title: 'Product Guides - Videos',
      },
    ],
  },
  {
    name: 'ENGAGE',
    url: '',
    child: [
      {
        id: 'events',
        url: `https://cleartax.in/s/webinars`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196264_events.png',
        title: 'Events',
      },
      {
        id: 'faqs',
        url: `https://docs.cleartax.in/product-help-and-support/faqs`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196276_faqs.png',
        title: 'FAQs',
      },
      {
        id: 'help_center',
        url: `https://cleartax.in/s/product-support`,
        icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1683196286_help_center.png',
        title: 'Help Center (Product Support)',
      },
    ],
  },
];

export const COMPANY_OPTIONS = [
  {
    name: '',
    url: '',
    child: [
      {
        id: 'support',
        url: `https://www.clear.in/s/contact-us`,
        icon: '',
        title: 'Support',
      },
      {
        id: 'about_us',
        url: `https://clear.in/s/about-us`,
        icon: '',
        title: 'About Us',
      },
      {
        id: 'career',
        url: `https://clear.in/s/careers`,
        icon: '',
        title: 'Careers',
      },
      {
        id: 'media_and_press',
        url: `https://clear.in/s/press`,
        icon: '',
        title: 'Media & Press',
      },
      {
        id: 'trust_and_safety',
        url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/trust`,
        icon: '',
        title: 'Trust and Safety',
      },
    ],
  },
];
